import { httpGet } from '../utils'

export default {
  getList (cb, { page, perPage }) {
    httpGet(`/api/form?page=${page}&per_page=${perPage}&order_by=last_fill_time`, cb)
  },
  getOne (cb, id) {
    httpGet(`/api/form/${id}`, cb)
  },
  getFeedbackList (cb, { id, page, perPage, searchName }) {
    let url = `/api/form/${id}/formfill?page=${page}&per_page=${perPage}&order_by=id`
    if (searchName) {
      url += `&name=${searchName}`
    }
    httpGet(url, cb)
  },
  getFeedbackDetail (cb, { contactId, formId, formfillId }) {
    if (contactId) {
      httpGet(`/api/contact/${contactId}/formfill/${formfillId}`, cb)
    } else if (formId) {
      httpGet(`/api/form/${formId}/formfill/${formfillId}`, cb)
    }
  },
  getRecordNoteMore (cb, { form_id, form_fill_id, current_num }) {
    httpGet(`/api/form/${form_id}/formFill/${form_fill_id}/getFormFillWithRecordNote/${current_num}`, cb)
  },
  getShare (cb, id) {
    httpGet(`/api/share/form/${id}`, cb)
  }
}



// WEBPACK FOOTER //
// ./src/api/lxm/form.js